import { Api_Video_LiveStreamAspectRatio } from '@core/api';
/**
 * Whether livestream or video orientation is horizontal (landscape).
 * Note: Square videos are considered vertical.
 * @returns
 */
export function isVideoHorizontal(video) {
    return video?.live_stream_aspect_ratio
        ? Boolean(video?.live_stream_aspect_ratio ===
            Api_Video_LiveStreamAspectRatio.HORIZONTAL)
        : Boolean(video && video.width && video.height && video.width > video.height);
}
